<template>
  <div v-loading="loading">
    <el-tag
      v-for="item in items"
      :key="item.msgId"
      size="medium"
      type="success"
      effect="plain"
      @click="selectitem(item)">
      {{ item.title }}
    </el-tag>
  </div>
</template>

<script>
export default {
  name: 'MessageInfo',
  props: {
    linkType: {
      type: Number,
      default: -1
    }
  },
  data() {
    return {
      loading: false,
      items: []
    }
  },
  mounted() {
    this.fetchList()
  },
  methods: {
    selectitem(item) {
      this.$emit('select', {
        linkType: this.linkType,
        link: item.msgId,
        title: item.title,
        contentType: item.contentType
      })
    },
    fetchList() {
      this.loading = true
      this.$store.dispatch('portal/getmessages', {
        payload: {
          pageNum: 1,
          pageSize: 10000
        },
        success: res => {
          this.loading = false
          this.items = res.data.records
        },
        fail: () => {
          this.loading = false
        }
      })
    }
  }
}
</script>

<style>

</style>
